import { CollapsibleRuleGroup } from '@wix/rules-panel-ui';
import React from 'react';
import { useStaticPageGroup } from './use-static-page-group';
export const StaticPageGroup = /*#__PURE__*/React.memo(_ref => {
  let {
    pageId
  } = _ref;
  const {
    staticPageRuleGroupProps
  } = useStaticPageGroup(pageId);
  return /*#__PURE__*/React.createElement(CollapsibleRuleGroup, staticPageRuleGroupProps);
});
//# sourceMappingURL=static-page-group.js.map